/** Used to match template delimiters. */
var reInterpolate = /<%=([\s\S]+?)%>/g;

if (!exports.__esModule) Object.defineProperty(exports, "__esModule", { value: true });exports.default = reInterpolate;
